import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_SNACKBAR } from '../../utils/types';
import { linkedAccountSignup } from '../../store/actions/tenantAction';

function ConnectInstagram({ setIsShow, onIntegrated }) {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const tenantReducer = useSelector((state) => state.tenantReducer);
    const globalReducer = useSelector((state) => state.globalReducer);

    useEffect(() => {
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const handleMessage = (event) => {
        if (event?.data?.type === 'meta_code') {
            dispatch(
                linkedAccountSignup(
                    {
                        code: event.data.code,
                        accountType: "INSTAGRAM",
                        bspId: tenantReducer.tenantDetails?.bsp?.id,
                        tenantId: tenantReducer.tenantDetails?.id,
                        tenantWabaId: globalReducer.waba?.id,
                    },
                    (r) => {
                        dispatch({
                            type: SHOW_SNACKBAR,
                            payload: {
                                type: "success",
                                message: "Instagram Connected Successfully.",
                                open: true,
                            },
                        });
                        setIsShow(false);
                        onIntegrated(r);
                    }
                )
            );
        }
    }

    const continueWithClick = () => {
        const popup = window.open(tenantReducer.tenantDetails?.bsp?.config?.instagramSignUpUrl, 'popup', 'width=600,height=400');
        if (popup) {
            popup.focus();
        }
    };

    return (
        <div className="bg-white max-h-[550px] overflow-auto">
            <div className="pt-2 pr-4 pl-4">
                <div>
                    <div className="text-[14px] min-h-[200px]">
                        <label className="font-semibold text-[16px]">
                            {t('Connect Instagram')}
                        </label>
                        <div className="text-gray-500">
                            <p className="mt-2 text-[13px]">
                                {t('Connect your Instagram account to the Instagram API to start chatting and managing messages directly from iOmnihub.')}
                            </p>
                            <ul className="mt-2 text-[13px] list-disc ml-7">
                                <li>
                                    {t("If your account is already connected, please disconnect it from Instagram before proceeding.")}
                                </li>
                                <li className="mt-2">
                                    {t("To keep your data safe, use our plugin to back up your Instagram chats.")}
                                </li>
                            </ul>
                        </div>
                        <div className="flex w-fit py-2 items-center px-4 bg-theme rounded-md text-white font-medium text-[16px] gap-2 mt-3">
                            <div>
                                <i className="fa-brands fa-instagram"></i>
                            </div>
                            <button
                                type="button"
                                className="text-[14px] transition-all ease-in-out rounded cursor-pointer"
                                onClick={continueWithClick}>
                                {t('Connect Instagram')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConnectInstagram